module.exports = __webpack_public_path__ + "static/9-img-1-2394f440a8bde5916f438b087b507398.png";